export { default } from './inscription-step-student';



// WEBPACK FOOTER //
// ./src/views/themes/front/components/inscription-step-student/index.js